import './App.css'
import React from 'react';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom"

import Homepage from "./pages/Homepage";
import CryptoWorld from "./pages/CryptoWorld";
import TokenFactory from "./pages/TokenFactory";
import NFTFactory from "./pages/NFTFactory";
import ContactUs from "./pages/ContactUs";
import Shop from './pages/Shop';
import TokenRequest from './pages/TokenRequest';
import TokenOrderProcess from './pages/TokenOrderProcess';
import Legals from './pages/Legals';
import PageNotFound from "./pages/PageNotFound";

/** Projects */
import ProjectShibConis from "./pages/ProjectShibConis";
import CryGIA_Marketplace from "./pages/CryGIA_Marketplace";
import CryptoCocktailParty from "./pages/CryptoCocktailParty";
import ProjectOldtimerNFT from './pages/ProjectOldtimerNFT';

const website_down = true;

function WebsiteDownPage() {
  return (
    <main className="website-down-wrapper">
      <section className="website-down-card" aria-live="polite">
        <p className="website-down-label">Maintenance Notice</p>
        <h1>Website currently not available</h1>
        <p>
          Our Startseite is temporarily offline due to scheduled maintenance.
          Please check back again shortly.
        </p>
      </section>
    </main>
  );
}

//useEffect hook tells our app to do something after rendering
function App()
{
  
  return (

    <BrowserRouter>
      <Routes>
        <Route index element ={<Navigate replace to ="Homepage"/>} />
        {website_down ? (
          <>
            <Route path="Homepage" element={<WebsiteDownPage />} />
            <Route path="*" element={<Navigate replace to="Homepage" />} />
          </>
        ) : (
          <>
            <Route path="Homepage" element ={<Homepage />} />
            <Route path="CryptoWorld" element ={<CryptoWorld />} />
            <Route path="TokenFactory" element ={<TokenFactory />} />
            <Route path="NFTFactory" element ={<NFTFactory />} />
            <Route path="CryGIA_Marketplace" element ={<CryGIA_Marketplace />} />
            <Route path="CryptoCocktailParty" element ={<CryptoCocktailParty />} />
            <Route path="ProjectOldtimerNFT" element ={<ProjectOldtimerNFT />} />
            <Route path="Shop" element ={<Shop />} />
            <Route path="TokenRequest" element ={<TokenRequest />} />
            <Route path="TokenOrderProcess" element ={<TokenOrderProcess />} />
            <Route path="ContactUs" element ={<ContactUs />} />
            <Route path="Legals" element ={<Legals />} />
            <Route path="*" element ={<PageNotFound />} />

            <Route path="ProjectShibConis" element={<ProjectShibConis />} />
          </>
        )}
      </Routes>
    </BrowserRouter>

  ) 
  
}

export default App;
